import { type FC } from "react";

import "./SelectComponent.scss";

import { type Skill } from "@entities";
import clsx from "clsx";
import { isMobile } from "react-device-detect";

interface SelectComponentProps {
  itemsList: Skill[] | undefined;
  chosenList: string[];
  title: string;
  isAdd?: boolean;
}

const SHOWN_ITEMS = isMobile ? 1 : 3;

export const SelectComponentSkills: FC<SelectComponentProps> = (props) => {
  const { itemsList, chosenList, title, isAdd } = props;
  const chosenSet = new Set(chosenList);
  const chosen = Array.from(chosenSet);
  if (!itemsList) return <div>-</div>;
  return (
    <div className="select-container">
      <label style={{ fontSize: "0.8rem", paddingLeft: "2rem" }}>{title}</label>
      <div className="list-items-container">
        {chosen.length
          ? <>
            {itemsList
              .filter((item) => chosen.includes(item.id))
              .slice(0, SHOWN_ITEMS)
              .map((item) => (
                <div
                  className={clsx("list-item", {
                    chosen: chosen?.includes(item.id),
                  })}
                  key={item.id}
                >
                  {item.name}
                </div>
              ))}
            {chosen.length > SHOWN_ITEMS && <div className="list-item more">{chosen.length - SHOWN_ITEMS}+</div>}
          </>
          : isAdd
            ? "קרתה תקלה"
            : "-"}
      </div>
    </div>
  );
};
